import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DesignationRoleSearch from "./desiri-roles-search";
import DesignationRoleTable from "./desiri-roles-table";
import designationRoleService from "../../services/desiriRoles/rolesservice";
import { DesignationRoleDTO } from "../../models/oilProduction-model";
import { BreadCrumb } from "primereact/breadcrumb";
const DesignationRolePage: React.FC = () => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [roles, setRoles] = useState<DesignationRoleDTO[]>([]);
  const [filteredRoles, setFilteredRoles] = useState<DesignationRoleDTO[]>([]);

  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText, roles]);

  const fetchRoles = async () => {
    try {
      const res = await designationRoleService.getAllDesignations();
      setRoles(res);
    } catch (error) {
      console.error("API error:", error);
      setRoles([]);
    }
  };
  const breadcrumbItems = [
    { label: "Master Data", url: "" },
    { label: "Roles and Designations", url: "" },
  ];
  const home = { icon: "pi pi-home", url: "/" };

  const handleSearch = (text: string) => {
    const terms = text.toLowerCase().trim().split(/\s+/);
    const filtered = roles.filter((r) => {
      const line = Object.values(r).join(" ").toLowerCase();
      return terms.every((term) => line.includes(term));
    });
    setFilteredRoles(filtered);
  };

  return (
    <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
      <div className="col-12">
        <h4 className="ml-1 mb-0">{t("Roles & Designations")}</h4>
      </div>
      {/* <BreadCrumb
        model={breadcrumbItems}
        home={home}
        className=" mb-2 bg-transparent px-0 py-0 text-sm  text-gray-600"
        style={{
          border: "none",
          boxShadow: "none",
          background: "transparent",
          marginLeft: "11px",
        }}
      /> */}
      <DesignationRoleSearch onSearch={setSearchText} onRefresh={fetchRoles} />
      <DesignationRoleTable data={filteredRoles} onRefresh={fetchRoles} />
    </div>
  );
};

export default DesignationRolePage;
